import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { AUTOMACAO_PAGES } from "@/lib/automacao-pages";

const data = AUTOMACAO_PAGES["automacao-comercial-para-empresas"];

export const Route = createFileRoute("/automacao-comercial-para-empresas")({
  head: () => ({
    meta: [
      { title: data.seoTitle },
      { name: "description", content: data.seoDescription },
      { property: "og:title", content: data.seoTitle },
      { property: "og:description", content: data.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.svgmultimidia.com.br/automacao-comercial-para-empresas" },
    ],
    links: [{ rel: "canonical", href: "https://www.svgmultimidia.com.br/automacao-comercial-para-empresas" }],
  }),
  component: () => <ServicePage {...data.page} />,
});
